import PropTypes from 'prop-types';
import {
  ALERT_STATUSES,
  CASE_STATUSES,
  ALERT_SOURCE_IDS,
  ALERT_LEVELS,
  HISTORY_ITEM_ACTION_TYPES,
  DOWNLOAD_SCREENS,
  REVIEW_STATUSES
} from '../constants/cmConstants';

export const ISOTimestamp = PropTypes.string;
export const EpochTimestampMs = PropTypes.number;

export const AlertLevelType = PropTypes.oneOf(ALERT_LEVELS);
export const AlertSourceIdType = PropTypes.oneOf(
  Object.values(ALERT_SOURCE_IDS)
);
export const HistoryItemActionType = PropTypes.oneOf(
  Object.keys(HISTORY_ITEM_ACTION_TYPES)
);
export const DownloadScreenType = PropTypes.oneOf(
  Object.values(DOWNLOAD_SCREENS)
);

export const AlertType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  sourceId: AlertSourceIdType.isRequired,
  timestamp: ISOTimestamp.isRequired,
  score: PropTypes.number.isRequired,
  level: AlertLevelType.isRequired,
  accountNumber: PropTypes.string,
  accountCurrency: PropTypes.string,
  typologyIds: PropTypes.arrayOf(PropTypes.number),
  typologyNames: PropTypes.arrayOf(PropTypes.string),
  customerId: PropTypes.string.isRequired,
  customerName: PropTypes.string.isRequired,
  metaDataId: PropTypes.number.isRequired
});

export const MetadataType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  assignedUsernameId: PropTypes.number,
  status: PropTypes.oneOf([...ALERT_STATUSES, ...CASE_STATUSES]).isRequired,
  caseAssignmentTimestamp: ISOTimestamp,
  lastStatusChangeTimestamp: ISOTimestamp
});

export const AssignedUserType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired
});

export const AlertDetailsType = PropTypes.shape({
  alert: AlertType,
  metadata: MetadataType,
  assignedUser: AssignedUserType
});

const CommonListFiltersShape = {
  status: PropTypes.oneOf([...ALERT_STATUSES, ...CASE_STATUSES]),
  alertLevel: AlertLevelType,
  from: EpochTimestampMs,
  to: EpochTimestampMs
};

export const CommonListFiltersType = PropTypes.shape(CommonListFiltersShape);

export const CasesByInvestigatorFiltersType = PropTypes.shape({
  ...CommonListFiltersShape,
  assignedUser: PropTypes.array,
  typologyIds: PropTypes.arrayOf(PropTypes.string),
  sourceIds: PropTypes.arrayOf(PropTypes.number)
});

export const CasesByDepartmentFiltersType = PropTypes.shape({
  ...CommonListFiltersShape,
  searchField: PropTypes.string.isRequired,
  searchText: PropTypes.string.isRequired,
  sortBy: PropTypes.string,
  sortByOrder: PropTypes.string,
  assignedUser: PropTypes.array,
  typologyIds: PropTypes.arrayOf(PropTypes.string),
  sourceIds: PropTypes.arrayOf(PropTypes.number)
});

export const CaseStatusType = PropTypes.oneOf(CASE_STATUSES);

export const CheckerStatusType = PropTypes.oneOf(Object.keys(REVIEW_STATUSES));

export const CaseType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  status: CaseStatusType.isRequired,
  lastStatusChangeTimestamp: ISOTimestamp,
  assignedUserId: PropTypes.number,
  assignedDepartmentId: PropTypes.number,
  createdTimestamp: ISOTimestamp.isRequired,
  makerId: PropTypes.number,
  checkerStatus: CheckerStatusType
});

export const DepartmentType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
});

export const CustomerType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const CaseDetailsType = PropTypes.shape({
  acase: CaseType.isRequired,
  assignedDepartment: DepartmentType,
  assignedUser: AssignedUserType,
  alerts: PropTypes.arrayOf(AlertDetailsType)
});

export const CaseListFiltersType = PropTypes.shape({
  department: PropTypes.number,
  assignedUser: PropTypes.array,
  sourceId: PropTypes.arrayOf(AlertSourceIdType),
  status: PropTypes.oneOf(CASE_STATUSES),
  alertLevel: AlertLevelType,
  from: EpochTimestampMs,
  to: EpochTimestampMs
});

export const UserType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  roles: PropTypes.array
});

export const UserInfoType = PropTypes.shape({
  user: UserType,
  departments: PropTypes.arrayOf(DepartmentType)
});

export const HistoryItemType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  caseId: PropTypes.number,
  alertId: PropTypes.string,
  usernameId: PropTypes.number,
  timestamp: ISOTimestamp.isRequired,
  actionType: HistoryItemActionType.isRequired,
  data: PropTypes.object // @todo make more specific
});

export const InvestigatorItem = PropTypes.shape({
  counts: PropTypes.shape({
    alerts: PropTypes.number,
    cases: PropTypes.arrayOf(
      PropTypes.shape({
        status: CaseStatusType,
        count: PropTypes.number
      })
    )
  }),
  user: UserType
});

export const MultiSelectOptions = PropTypes.shape({
  title: PropTypes.string,
  value: PropTypes.number
});
